import React__default from 'react';
import { F as Flex } from '../Flex/Flex-DZMfgrzg.js';
import { T as TooltipScrollContainer, a as TooltipContent, b as TooltipMessage } from './Tooltip.styles-SI60iUeO.js';
import { C as CloseButton } from '../Button/CloseButton/CloseButton-cLZyFeIM.js';
import { T as Text } from '../Text/Text-DvcofqkP.js';

const TooltipContentContainer = ({
  children,
  closeButtonLabel = 'Close Tooltip',
  closeIconPosition = 'default',
  footer,
  handleCloseClicked,
  message = '',
  messageId,
  withCloseButton = true
}) => {
  const DefaultLayout = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Flex, {
    direction: "row-reverse",
    columnGap: "xsmall"
  }, withCloseButton && /*#__PURE__*/React__default.createElement(CloseButton, {
    label: closeButtonLabel,
    onClick: handleCloseClicked,
    size: "small"
  }), /*#__PURE__*/React__default.createElement(TooltipMessage, {
    direction: "column",
    justifyContent: "center",
    id: messageId
  }, message ? /*#__PURE__*/React__default.createElement(Text, {
    renderAs: "span"
  }, message) : children)));
  const TopCornerCloseIconLayout = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Flex, {
    justifyContent: "flex-end"
  }, /*#__PURE__*/React__default.createElement(CloseButton, {
    label: closeButtonLabel,
    onClick: handleCloseClicked,
    size: "small"
  })), /*#__PURE__*/React__default.createElement(TooltipMessage, {
    direction: "column",
    justifyContent: "center",
    id: messageId
  }, message ? /*#__PURE__*/React__default.createElement(Text, {
    renderAs: "span"
  }, message) : children));
  return /*#__PURE__*/React__default.createElement(TooltipScrollContainer, null, /*#__PURE__*/React__default.createElement(TooltipContent, null, closeIconPosition === 'topCorner' ? TopCornerCloseIconLayout : DefaultLayout, footer && /*#__PURE__*/React__default.createElement(Flex, null, footer)));
};

export { TooltipContentContainer as T };
//# sourceMappingURL=TooltipContent-DBvs0RLe.js.map
